import { enums, Infer } from "superstruct";

export const PlatformUiEnv = enums(["local", "platform-prod", "platform-dev"]);

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PlatformUiEnv = Infer<typeof PlatformUiEnv>;
